import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Grid,
   IconButton,
   Paper,
   Typography,
   Backdrop,
   InputAdornment,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { Controller, useForm } from 'react-hook-form';
import { TitleLabel } from '../../../components/Element/LabelInputForm';
import 'react-nice-dates/build/style.css';
import {
   AlertLabel,
   Input,
   TextFieldCustom,
} from '../../../assets/styled/Element';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { reverseFormatNumber } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { MySelect } from '../../Select/Select';
// import SearchRule from '../../Search/SearchRule';
import SearchEmployee from '../../Search/SearchEmployee';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';
const limitRelatedPerson = 2;

const useStyles = makeStyles((theme) => ({
   backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
   },
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '55%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
function Edit(props) {
   const classes = useStyles();
   const [relatedPersons, setRelatedPersons] = useState([]);
   const [tableData, setTableData] = useState([]);
   const [data, setData] = useState(props.data);
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {
         year: data.year ? { label: +data.year + 543, value: data.year } : null,
         ruleCode: data.ruleCode,
         ruleNameTh: data.ruleNameTh,
         ruleNameEn: data.ruleNameEn,
         ruleConditionTh: data.ruleConditionTh,
         ruleConditionEn: data.ruleConditionEn,
         referenceDescription: data.ruleReferenceDescription,
         rulePointAmount: new Intl.NumberFormat().format(data.remainingPoint),
         gPoint: new Intl.NumberFormat().format(data.gPoint),
         sPoint: new Intl.NumberFormat().format(data.sPoint),
         bPoint: new Intl.NumberFormat().format(data.bPoint),
         hrWallet: data.hrWalletNameTh,
         parentRule: `${data.parentRuleCode} : ${data.parentRuleNameTh}`,
      },
   });
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const closeRef = useRef();
   const selectCheckbox = watch('isUseParentWallet');
   const [ruleCode, setRuleCode] = useState('');
   const [years, setYears] = useState([]);

   useEffect(() => {
      let temp = props.data.relatedPersons.map((el, i) => {
         return {
            seq: i + 1,
            data: el,
            label: el.description,
            value: el.employeeId,
         };
      });
      setRelatedPersons(temp);
      setTableData(temp);
      setYearsDropdown();
   }, []);
   const setYearsDropdown = () => {
      const currentDate = new Date();
      let years = [];
      let startYear = currentDate.getFullYear() - 2;
      for (let i = 0; i < 7; i++) {
         years.push({
            value: startYear.toString(),
            label: (startYear + 543).toString(),
         });
         startYear += 1;
      }
      setYears(years);
   };
   useEffect(() => {
      if (tableData == null) {
         setTableData([]);
      }
   }, [tableData]);

   const onSelected = (e) => {
      if (e == null) {
         e = [];
      }
      e.map((el, i) => (el.seq = i + 1));
      setTableData(e);
      setRelatedPersons(e);
   };

   const onDelete = (rowData) => {
      let deleted = tableData.filter((e) => e.seq !== rowData.seq);
      setTableData(deleted);
      setRelatedPersons(deleted);
   };

   useEffect(() => {
      register({ name: 'isUseParentWallet' });
   }, [register]);
   const handlesUseParentWallet = (e) => {
      setValue('isUseParentWallet', e.target.checked);
   };
   const onSubmit = async (values) => {
      setIsLoading(true);
      let relatePersonsTemp = relatedPersons.map((el) =>
         Object.assign(el.data.employeeId),
      );
      const payload = {
         year: values.year.value,
         ruleCode:
            values.ruleCode !== data.ruleCode
               ? values.ruleCode.trim()
                  ? values.ruleCode.trim()
                  : '-'
               : null,
         ruleNameTh:
            values.ruleNameTh !== data.ruleNameTh
               ? values.ruleNameTh.trim()
                  ? values.ruleNameTh.trim()
                  : '-'
               : null,
         ruleNameEn:
            values.ruleNameEn !== data.ruleNameEn
               ? values.ruleNameEn.trim()
                  ? values.ruleNameEn.trim()
                  : '-'
               : null,
         ruleConditionTh:
            values.ruleConditionTh !== data.ruleConditionTh
               ? values.ruleConditionTh.trim()
                  ? values.ruleConditionTh.trim()
                  : '-'
               : null,
         ruleConditionEn:
            values.ruleConditionEn !== data.ruleConditionEn
               ? values.ruleConditionEn.trim()
                  ? values.ruleConditionEn.trim()
                  : '-'
               : null,
         referenceDescription:
            values.referenceDescription !== data.ruleReferenceDescription
               ? values.referenceDescription.trim()
                  ? values.referenceDescription.trim()
                  : '-'
               : null,
         ruleId: data.ruleId,
         // ruleCode: values.ruleCode,
         // ruleParentId: values.rule ? values.rule.data.ruleId : null,
         // isUseParentWallet: values.isUseParentWallet ? values.isUseParentWallet : false,
         // rulePoint: values.rulePointAmount
         //   ? +reverseFormatNumber(values.rulePointAmount, 'en')
         //   : 0,
         rulePoint: null,
         gPoint: values.gPoint ? +reverseFormatNumber(values.gPoint, 'en') : 0,
         sPoint: values.sPoint ? +reverseFormatNumber(values.sPoint, 'en') : 0,
         bPoint: values.bPoint ? +reverseFormatNumber(values.bPoint, 'en') : 0,
         relatedEmployeeOrgId: relatePersonsTemp,
      };
      Axios.post('/GSB/dashboard/rule/EditRule', payload)
         .then((resp) => {
            enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <Backdrop className={classes.backdrop} open={isLoading}>
            <LoadingPopup />
         </Backdrop>
         <div className={classes.header}>
            <Typography variant={'h4'}>แก้ไขหลักเกณฑ์</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <form onSubmit={handleSubmit(onSubmit)}>
            <Box
               display={'flex'}
               alignItems={'flex-start'}
               flexDirection={'column'}
               fontSize={20}
            >
               <Box display={'flex'} width={'100%'}>
                  <Grid container spacing={1}>
                     <Grid item xs={6}>
                        <TitleLabel>
                           รหัสหลักเกณฑ์
                           {errors.ruleCode && (
                              <AlertLabel>กรุณาระบุรหัสหลักเกณฑ์</AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleCode'}
                           ref={register({ required: true })}
                           // disabled
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ปี
                           {errors.year && (
                              <AlertLabel>กรุณาเลือกปี</AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={
                              <MySelect
                                 options={years}
                                 placeholder={'เลือกปี'}
                                 closeMenuOnSelect
                                 menuShowInbody
                              />
                           }
                           onChange={([selected]) => {
                              return selected;
                           }}
                           name='year'
                           rules={{ required: true }}
                           control={control}
                        />
                     </Grid>
                     {data.hrWalletNameTh && (
                        <Grid item xs={12}>
                           <TitleLabel>กระเป๋าส่วนกลาง (HR)</TitleLabel>
                           <Input name={'hrWallet'} ref={register()} disabled />
                        </Grid>
                     )}
                     {data.parentRuleNameTh && (
                        <Grid item xs={12}>
                           <TitleLabel>หลักเกณฑ์หลัก</TitleLabel>
                           <Input
                              name={'parentRule'}
                              ref={register()}
                              disabled
                           />
                        </Grid>
                     )}
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อหลักเกณฑ์ภาษาไทย
                           {errors.ruleNameTh && (
                              <AlertLabel>
                                 กรุณาระบุชื่อหลักเกณฑ์ภาษาไทย
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleNameTh'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           ชื่อหลักเกณฑ์ภาษาอังกฤษ
                           {errors.ruleNameEn && (
                              <AlertLabel>
                                 กรุณาระบุชื่อหลักเกณฑ์ภาษาอังกฤษ
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleNameEn'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เงื่อนไขหลักเกณฑ์ภาษาไทย
                           {errors.ruleConditionTh && (
                              <AlertLabel>
                                 กรุณาระบุเงื่อนไขหลักเกณฑ์ภาษาไทย
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleConditionTh'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={6}>
                        <TitleLabel>
                           เงื่อนไขหลักเกณฑ์ภาษาอังกฤษ
                           {errors.ruleConditionEn && (
                              <AlertLabel>
                                 กรุณาระบุเงื่อนไขหลักเกณฑ์ภาษาอังกฤษ
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Input
                           name={'ruleConditionEn'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>รายละเอียดอ้างอิง</TitleLabel>
                        <Input
                           name={'referenceDescription'}
                           ref={register({ required: true })}
                        />
                     </Grid>
                     {/* <Grid item xs={12}>
                <TitleLabel>ruleParentId</TitleLabel>
                <Controller
                  as={<SearchRule />}
                  onChange={([selected]) => selected}
                  name="rule"
                  control={control}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name={"isUseParentWallet"}
                      color={"primary"}
                      size={"small"}
                      checked={selectCheckbox}
                      onChange={handlesUseParentWallet}
                    />
                  }
                  label={"isUseParentWallet"}
                />
              </Grid>*/}
                     <Grid item xs={6}>
                        <TitleLabel>
                           คะแนนหลักเกณฑ์คงเหลือ
                           {errors.rulePointAmount && (
                              <AlertLabel>
                                 กรุณาระบุคะแนนหลักเกณฑ์คงเหลือ
                              </AlertLabel>
                           )}
                        </TitleLabel>
                        <Controller
                           as={<Input textAlign={'right'} disabled />}
                           rules={{ required: true }}
                           onChange={([e]) => {
                              return new Intl.NumberFormat().format(
                                 e.target.value.replace(/[^0-9]/g, ''),
                              );
                           }}
                           name={'rulePointAmount'}
                           control={control}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <TitleLabel>
                           คะแนนแยกตามหน่วย (GSB Way of Work)
                        </TitleLabel>
                        <Box display='flex' gridGap={'8px'}>
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'B'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             for SOCIETY
                                          </InputAdornment>
                                       ),
                                    }}
                                    disabled
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'bPoint'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'G'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             with GOVERNANCE
                                          </InputAdornment>
                                       ),
                                    }}
                                    disabled
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'gPoint'}
                              control={control}
                           />
                           <Controller
                              as={
                                 <TextFieldCustom
                                    textAlign={'right'}
                                    width={'33.33%'}
                                    placeholder={'S'}
                                    variant='outlined'
                                    size='small'
                                    InputProps={{
                                       startAdornment: (
                                          <InputAdornment position='start'>
                                             through DIGITALIZATION
                                          </InputAdornment>
                                       ),
                                    }}
                                    disabled
                                 />
                              }
                              onChange={([e]) => {
                                 return new Intl.NumberFormat().format(
                                    e.target.value.replace(/[^0-9]/g, ''),
                                 );
                              }}
                              name={'sPoint'}
                              control={control}
                           />
                        </Box>
                     </Grid>
                     <Grid item xs={8}>
                        <TitleLabel>
                           รายชื่อผู้เกี่ยวข้อง
                           <AlertLabel>(สามารถเพิ่มได้ไม่เกิน 2 คน)</AlertLabel>
                        </TitleLabel>
                        <SearchEmployee
                           value={relatedPersons}
                           isSearchable={
                              relatedPersons &&
                              relatedPersons.length != limitRelatedPerson
                           }
                           isMulti
                           onChange={onSelected}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <MaterialTable
                           columns={[
                              {
                                 field: 'seq',
                                 title: '#',
                              },
                              {
                                 field: 'data.employeeId',
                                 title: 'รหัสพนักงาน',
                              },
                              {
                                 field: 'data.displayName',
                                 title: 'ชื่อ-นามสกุล',
                              },
                              {
                                 field: 'data.department',
                                 title: 'สังกัด',
                              },
                           ]}
                           data={tableData}
                           options={{
                              showTitle: false,
                              headerStyle: headerStyle,
                              padding: 'dense',
                              search: false,
                              toolbar: false,
                              actionsColumnIndex: -1,
                              actionsCellStyle: {
                                 color: '#ccc',
                              },
                              pageSize: 5,
                              pageSizeOptions: [5, 10, 25, 50, 100],
                           }}
                           localization={{
                              header: { actions: 'ตัวจัดการ' },
                           }}
                           style={tableStyle}
                           icons={tableIcons}
                           actions={[
                              (rowData) => ({
                                 icon: React.forwardRef((props, ref) => (
                                    <FontAwesomeIcon
                                       ref={ref}
                                       {...props}
                                       color={'#ed1c24'}
                                       icon={faTrashAlt}
                                    />
                                 )),
                                 onClick: (e, rowData) => onDelete(rowData),
                                 tooltip: 'ลบ',
                              }),
                           ]}
                        />
                     </Grid>
                     <Grid item xs={12}>
                        <Box>
                           <Button
                              variant='contained'
                              color='primary'
                              type={'submit'}
                           >
                              ยืนยัน
                           </Button>
                           <Button
                              variant='contained'
                              onClick={props.onClickClose}
                           >
                              ยกเลิก
                           </Button>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
            </Box>
         </form>
      </Paper>
   );
}

export default Edit;
